<template>
  <v-select
    v-model="item"
    :items="itens"
    item-text="desc"
    item-value="id"
    @change="changeDate()"
  ></v-select>
</template>

<script>
const moment = require("moment");
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      item: 3,
      itens: [
        { desc: "Hoje", value: 1, param: "days", id: 1 },
        { desc: "Ontem", value: 1, param: "days", id: 2 },
        { desc: "Últimos 7 Dias", value: 7, param: "days", id: 3 },
        { desc: "Últimos 15 Dias", value: 15, param: "days", id: 4 },
        { desc: "Últimos 30 Dias", value: 30, param: "days", id: 5 },
        { desc: "Últimos 3 meses", value: 3, param: "months", id: 6 },
        { desc: "Últimos 6 meses", value: 6, param: "months", id: 7 },
        { desc: "Período", value: 0, param: "" }
      ]
    };
  },
  computed: {
    ...mapGetters("appAnalytics", ["getFilter"])
  },
  methods: {
    ...mapActions("appAnalytics", ["setFilter"]),
    changeDate() {
      const test = this.itens.filter(a => {
        return a.id == this.item;
      });
      if (test[0].value == 0) {
        return;
      }
      const dt = moment();
      const now = moment().format("YYYY-MM-DD");
      const lastDays = dt.subtract(test[0].value, test[0].param);
      this.setFilter({
        withCompany: false,
        empresas: [],
        date: [lastDays.format("YYYY-MM-DD"), now]
      });
    }
  }
};
</script>

<style scoped></style>
